class AddUserInsurerType {
  construction() {
    this.BlockofBussiness = '';
    this.AddEmployer = '';
    this.AddLocation = '';
    this.AddGroups = '';
  }

  getBlockofBussiness() {
    return this.BlockofBussiness;
  }

  setBlockofBussiness(BlockofBussiness) {
    this.BlockofBussiness = BlockofBussiness;
  }

  getAddEmployer() {
    return this.AddEmployer;
  }

  setAddEmployer(AddEmployer) {
    this.AddEmployer = AddEmployer;
  }

  getAddLocation() {
    return this.AddLocation;
  }

  setAddLocation(AddLocation) {
    this.AddLocation = AddLocation;
  }

  getAddGroups() {
    return this.AddGroups;
  }

  setAddGroups(AddGroups) {
    this.AddGroups = AddGroups;
  }

  resetAddUersInsurer() {
    this.BlockofBussiness = '';
    this.AddEmployer = '';
    this.AddLocation = '';
    this.AddGroups = ';';
  }
}
export default new AddUserInsurerType();
